module.exports = __webpack_public_path__ + "static/img/24.e6bae76.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/Brochure/24.jpg
// module id = 9ElC
// module chunks = 1